import { useQuery } from "@tanstack/react-query";
import { api } from "./api.js";
export function useRecoveryAvailable(): boolean {
  const result = useQuery({
    queryKey: ["account-recovery-availability"],
    queryFn: ({ signal }) => api.get<{ available: boolean }>("/auth/recovery-availability", signal),
    staleTime: 30_000,
    retry: false,
  });
  return !result.isError && result.data?.available === true;
}
